export type CertificateType = 'passed' | 'participated' | 'none';

export function needsThresholdWarning(
    type: CertificateType | '',
    lessons: Array<{ minScore?: number | null }> | undefined
): boolean {
    return type === 'passed' && !(lessons || []).some((l) => l?.minScore != null && l.minScore > 0);
}
